module.exports = __webpack_public_path__ + "img/e-commerce-1.f3e50c4.jpeg";